/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import * as labsComponents from 'vuetify/labs/components'

// Composables
import { createVuetify } from 'vuetify'   


console.log('import.meta.env["VITE_ENVIRONMENT"]', import.meta.env["VITE_ENVIRONMENT"])


let primary = '#1867C0'

if (import.meta.env["VITE_ENVIRONMENT"] == "production") {
  primary = '#d69302'
}


// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    ...labsComponents
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: primary,
          secondary: '#5CBBF6',
        },
      },
    },
  },
})  
